export type DocumentTemplateType = {
	title: string
	contentBuckets: Array<{
		bucketTitle: string
		className?: string
		lastUpdated?: string
		content: Array<{
			title?: string | JSX.Element
			text: string | JSX.Element
		}>
	}>
}

const DocumentTemplate = ({ title, contentBuckets }: DocumentTemplateType) => {
	return (
		<div>
			<div className="object-cover md:gap-16 flex justify-center items-center h-[265px] md:h-[400px]">
				<img
					src="/images/harvest-bg.webp"
					alt="Document BG"
					className="object-cover size-full 2xl:aspect-[21/9]"
				/>
				<div className="absolute flex flex-col items-center justify-center text-center pt-16 px-6 gap-5">
					<h1 className="text-[3.75rem] md:text-[6.25rem] uppercase drop-shadow-strong text-neutral leading-none">
						{title}
					</h1>
				</div>
			</div>
			{contentBuckets.map((bucket, idx) => (
				<div
					className={`size-full flex md:p-[60px] px-[24px] py-[40px] flex-row gap-[80px] ${bucket.className} `}
					key={idx}
				>
					<div className="flex flex-col gap-10">
						<div className="flex flex-col gap-[10px]">
							<h1 className="text-neutral-100 leading-none uppercase md:text-[60px] text-[3.75rem] md:self-auto self-center">
								{bucket.bucketTitle}
							</h1>
							{bucket.lastUpdated && (
								<p className="h-[22px] text-[2rem] text-neutral-40">
									{`Last Updated: ${bucket.lastUpdated}`}
								</p>
							)}
						</div>
						<div className="flex flex-col gap-[40px]">
							{bucket.content.map((item, idxx) => (
								<div className="flex flex-col gap-3" key={`${idx}:${idxx}`}>
									{item.title && (
										<h1 className="text-[1.75rem] text-neutral-100 leading-none uppercase">
											{item.title}
										</h1>
									)}
									<div className="whitespace-pre-wrap text-[1.5rem] text-neutral-40 font-semibold leading-6">
										{item.text}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			))}
		</div>
	)
}

export default DocumentTemplate
